module.exports = __webpack_public_path__ + "static/media/chat-private-bubble.c38611a4.svg";